export const convertDate = (date: Date | string | undefined): string | undefined => {
    if (typeof date === 'string') {
        return date;
    } else if (date instanceof Date) {
        return date.toISOString();
    }
    return undefined;
};
